export default "__VITE_ASSET__B5r4y8G6__"